import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { MosError } from 'src/utils/errors/MosError';

export interface DeleteLoanMappingParams {
  loanId: string;
  mappingId: string;
}

export interface DeleteLoanMappingResponse {
  success: boolean;
  message?: string;
}

const deleteLoanMapping: MutationFunction<
  DeleteLoanMappingResponse,
  DeleteLoanMappingParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteLoanMappingResponse>(
    `/loans/${args.loanId}/loan-mappings/${args.mappingId}`,
    {
      method: 'DELETE',
    },
  );

  if (response.success) return response.data as DeleteLoanMappingResponse;

  throw new MosError({
    message: 'Failed to delete loan mapping',
    statusCode: response.status,
  });
};

export default deleteLoanMapping;

const _mockData: DeleteLoanMappingResponse = {
  success: true,
  message: 'Loan mapping deleted successfully',
};
